(() => {
    const initializeStarumiMobileSearch = () => {
        const largeSearch = document.querySelector('[data-starumi-mobile-large-search]');
        const mobileHeader = document.querySelector('.section-header-mobile');

        if (!largeSearch || !mobileHeader || largeSearch.dataset.observerReady === 'true') return;

        largeSearch.dataset.observerReady = 'true';

        const setCollapsed = (collapsed) => {
            mobileHeader.classList.toggle('is-search-collapsed', collapsed);
            document.body.classList.toggle('starumi-mobile-search-collapsed', collapsed);
        };

        const observer = new IntersectionObserver((entries) => {
            setCollapsed(!entries[0].isIntersecting);
        }, { threshold: 0 });

        observer.observe(largeSearch);

        document.addEventListener('shopify:section:unload', (event) => {
            if (event.target === mobileHeader || event.target.contains(largeSearch)) observer.disconnect();
        }, { once: true });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeStarumiMobileSearch, { once: true });
    } else {
        initializeStarumiMobileSearch();
    }
})();
